const Footer = () => {
	return (
		<footer className="bg-gray-50 border-t border-black py-8 mt-16">
			<div className="max-w-6xl mx-auto px-6 text-center">
				<p className="text-gray-900 text-sm font-medium">
					© {new Date().getFullYear()} Bark By Borders. All rights reserved.
				</p>
			</div>
		</footer>
	);
};

export default Footer;

